import {
  AI_BRAIN_TOKEN_EXPIRED_DETAIL,
  AI_LLM_UNAVAILABLE_REPLY_MARKERS,
  AIConversationGenerationStatus,
  AIConversationMessageEventCode,
  AIConversationStopOutcome,
  AIErrorCode,
} from '../constants/aiAgents'

import { isApiUnauthorizedStatus } from './api'

export function isServiceUnavailableReply(text) {
  if (!text) {
    return false
  }

  const normalized = text.toLowerCase()

  return AI_LLM_UNAVAILABLE_REPLY_MARKERS.some(marker =>
    normalized.includes(marker)
  )
}

export function isAIMessageStopped(metadata) {
  return metadata?.stopped === true
}

export function getAISuggestSource(metadata) {
  return metadata?.suggest_source ?? null
}

export function getAICompletionMetadata(response) {
  return response?.data?.choices?.[0]?.message?.metadata ?? null
}

export function getAIErrorCode(reason) {
  return reason?.response?.data?.error?.code ?? null
}

export function isAIFinanceAccessRevokedCode(code) {
  return code === AIErrorCode.FinanceAccessRevoked
}

export function isAIFinanceAccessDeniedCode(code) {
  return code === AIErrorCode.FinanceAccessDenied
}

export function isAISourceUnavailableCode(code) {
  return code === AIErrorCode.SourceUnavailable
}

export function isAIFinanceAccessRevokedError(reason) {
  const code = getAIErrorCode(reason)

  return isAIFinanceAccessRevokedCode(code) || isAIFinanceAccessDeniedCode(code)
}

export function isAISourceUnavailableError(reason) {
  return isAISourceUnavailableCode(getAIErrorCode(reason))
}

export function isAIBrainTokenExpiredError(reason) {
  return (
    isApiUnauthorizedStatus(reason?.response?.status) &&
    reason?.response?.data?.detail === AI_BRAIN_TOKEN_EXPIRED_DETAIL
  )
}

export function getAIConversationGenerationStatus(response) {
  return response?.data?.generation_status ?? null
}

export function isAIConversationGenerationRunning(response) {
  return isAIConversationGenerationStatusRunning(
    getAIConversationGenerationStatus(response)
  )
}

export function isAIConversationGenerationFailed(response) {
  return (
    getAIConversationGenerationStatus(response) ===
    AIConversationGenerationStatus.Failed
  )
}

export function isAIConversationGenerationStatusRunning(status) {
  return status === AIConversationGenerationStatus.Running
}

export function hasAIConversationPendingAnswers(response) {
  return response.data.length > 0
}

// Oldest-first per the contract — the oldest open document read is the one worth naming.
export function getAIConversationPendingAnswerFileName(response) {
  return response?.data?.[0]?.filename ?? null
}

export function getAIConversationMessageEventCode(message) {
  return message?.event_code ?? null
}

export function isAIConversationMessageFailed(message) {
  return (
    getAIConversationMessageEventCode(message) ===
    AIConversationMessageEventCode.Failed
  )
}

export function isAIConversationMessageEvent(message) {
  return Boolean(getAIConversationMessageEventCode(message))
}

export function getAIStopTurnOutcome(response) {
  return response?.data?.status ?? null
}

export function isAIStopTurnRequested(response) {
  return (
    getAIStopTurnOutcome(response) === AIConversationStopOutcome.StopRequested
  )
}
